import { COMPETITOR_FREQUENCY_LABELS, type Competitor } from '@/api/market'
import { formatCurrency, formatInteger, type Column, type FormatOptions } from '@/design'

/** The competitor fields every table of competitors shows — the competitors list and the side-by-side comparison. */
export function competitorColumns(money: FormatOptions): Column<Competitor>[] {
  return [
    { key: 'name', header: 'Competitor', sortValue: (row) => row.name, cell: (row) => row.name },
    { key: 'domain', header: 'Domain', cell: (row) => row.domain },
    { key: 'brand', header: 'Brand', sortValue: (row) => row.brand, cell: (row) => row.brand },
    { key: 'frequency', header: 'Frequency', sortValue: (row) => row.frequency, cell: (row) => COMPETITOR_FREQUENCY_LABELS[row.frequency] },
    {
      key: 'price',
      header: 'Typical ticket price',
      align: 'end',
      sortValue: (row) => row.typicalTicketPrice,
      cell: (row) => formatCurrency(row.typicalTicketPrice, money),
    },
    {
      key: 'active',
      header: 'Active competitions',
      align: 'end',
      sortValue: (row) => row.activeCompetitions,
      cell: (row) => formatInteger(row.activeCompetitions),
    },
    {
      key: 'categories',
      header: 'Prize categories',
      cell: (row) => <span className="mk-tags">{row.prizeCategories.join(', ') || '—'}</span>,
    },
  ]
}
